<li class="trigger" (click)="showPopup($event)">
  <span class="text plus-sign">+</span>
  <span class="text">Add a new DTMF Marker</span>
</li>
<pop-over #popup [x-offset]="300" [my]="'top left'" [at]="'bottom right'">
  <div class="popover-container">
    <h3 class="title">Add a new DTMF marker</h3>

    <radio-collection
      [horizontal]="true"
      (output)="onInoutChange($event)"
      [options]="inOutOptions"
      [key]="'label'"
    ></radio-collection>

    <span class="space-bottom">Max range between in and out markers</span>
    <icn-number-input
      [ngStyle]="{ width: '60%' }"
      (valueChange)="onRangeChange($event)"
      [min]="1"
      [sign]="'sec'"
    ></icn-number-input>

    <span>Marker Code</span>
    <ichannel-input
      [placeholder]="'Enter marker code...'"
      [direction]="'column'"
    ></ichannel-input>

    <span>Marker Name</span>
    <ichannel-input
      [placeholder]="'Enter marker name...'"
      [direction]="'column'"
    ></ichannel-input>

    <div class="button">CREATE</div>
  </div>
</pop-over>
